module.exports = __webpack_public_path__ + "images/9ff5974afe9dc8a90c4ab86d7910eaa8-illu_dir_door3.svg";